import configGenerator from "./config-generator";
export default configGenerator;
